
import React, {
    useState,
    useEffect,
    useContext,
    useRef
}
from "react";

import {
    store
}
from "../../context/store";

import {
    functions
}
from "../../constants/common-functions";

import {
    colorFunctions
}
from "../../constants/colors";

import {
    useHistory
}
from "react-router-dom";

import Header
from "../../components/Header";

import LeftMenu
from "../../components/LeftMenu";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    STRINGIFY
}
from "../../constants/general-constants";

import background
from "../../../images/background.jpg";

import HeaderCard
from "../home/components/HeaderCard";

import HomeBoxProperties
from "../home/components/HomeBoxProperties";

import HomeBoxSpace
from "../home/components/HomeBoxSpace";

import HomeBoxDocuments
from "../home/components/HomeBoxDocuments";

import HomeBoxLeases
from "../home/components/HomeBoxLeases";

import HomeBoxProjects
from "../home/components/HomeBoxProjects";

import HomeBoxHelpDesk
from "../home/components/HomeBoxHelpDesk";

import HomeBoxTasks
from "../home/components/HomeBoxTasks";

import HomeBoxMyTasks
from "../home/components/HomeBoxMyTasks";

import HomeDocumentsPanel
from "../home/components/HomeDocumentsPanel";

import AiInsightsPanel
from "../home/components/AiInsightsPanel";

import OmniScanEntry
from "./OmniScanEntry";

import {
    SYSTEM_ROLE_SUPERADMIN
}
from "../../constants/general-constants";

import {
    SYSTEM_ROLE_ADMIN
}
from "../../constants/general-constants";

import {
    SYSTEM_ROLE_CONTENT_CREATOR
}
from "../../constants/general-constants";

import {
    DEFAULT_BLUE_GRADIENT
}
from "../../constants/styles";

import HomeDataScroller
from "../home/components/datascroller/HomeDataScroller";

import {
    OMNISCAN_CORPORATE_RED,
    OMNISCAN_CORPORATE_GREEN,
    OMNISCAN_CORPORATE_PURPLE,
    OMNISCAN_BLUE
}
from "../../constants/colors";

import MobileHome
from "./mobile/MobileHome";


import "./Home.css";


//============================================================
//
// Home
//
//============================================================

export default function Home()
{

    //--------------------------------------------------------
    // Context
    //--------------------------------------------------------

    const globalState =
        useContext(
            store
        );

    const history =
        useHistory();


    //--------------------------------------------------------
    // References
    //--------------------------------------------------------

    const searchId =
        useRef(
            null
        );


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [locations, setLocations] =
        useState([]);

    const [likeString, setLikeString] =
        useState("");

    const [posLeft, setPosLeft] =
        useState("0");

    const [posTop, setPosTop] =
        useState("0");

    const [displayResults, setDisplayResults] =
        useState("none");

    const [externalLinks, setExternalLinks] =
        useState([]);

    const [displayBlur, setDisplayBlur] =
        useState(false);

    const [homeConfig, setHomeConfig] =
        useState();

    const [directories, setDirectories] =
        useState([]);
		
	//========================================================
	// OmniScan Information Screen
	//========================================================

	const [showOmniScanInfo, setShowOmniScanInfo] =
	    useState(false);


    //--------------------------------------------------------
    // Environment
    //--------------------------------------------------------

    const isLocalHost =
        functions.getIsDemoSystem();


    //--------------------------------------------------------
    // Responsive layout
    //--------------------------------------------------------

    const isMobile =
        window.innerWidth <= 768;

    const isTablet =
        window.innerWidth > 768
        &&
        window.innerWidth <= 1200;


    //========================================================
    // Initialise
    //========================================================

    useEffect(
        function()
        {

            //------------------------------------------------
            // User
            //------------------------------------------------

            functions.getObjectFromAjax(
                "/resolutionsoftwareplatform/getuser",
                null,
                handleUser
            );


            //------------------------------------------------
            // Search position
            //------------------------------------------------

            if(
                searchId.current
            )
            {

                const rect =
                    searchId.current
                        .getBoundingClientRect();

                setPosLeft(
                    rect.left
                );

                setPosTop(
                    rect.top + 52
                );

            }


            //------------------------------------------------
            // External links
            //------------------------------------------------

            functions.getArrayFromAjax(
                "/resolutionsoftwareplatform/externallinks?pageIndex=1",
                null,
                setExternalLinks
            );


            //------------------------------------------------
            // Reset filter
            //------------------------------------------------

            functions.submitAjax(
                "/resolutionsoftwareplatform/resetfilter",
                {},
                function()
                {
                },
                STRINGIFY,
                function(e)
                {
                    console.log(e);
                }
            );


            //------------------------------------------------
            // Home setup
            //------------------------------------------------

            functions.getObjectFromAjax(
                "/resolutionsoftwareplatform/home-setup",
                setHomeConfig,
                null
            );


            //------------------------------------------------
            // Forager directories
            //------------------------------------------------

            functions.getObjectFromAjax(
                "/resolutionsoftwareplatform/folderforager/directories",
                setDirectories,
                null
            );

        },
        []
    );


    //========================================================
    // Search
    //========================================================

    useEffect(
        function()
        {

            if(
                likeString.length > 3
            )
            {

                functions.getObjectFromAjax(
                    "/resolutionsoftwareplatform/facilitieslike?like="
                    +
                    likeString,
                    setLocations,
                    null
                );

                setDisplayResults(
                    "flex"
                );

            }
            else
            {

                setLocations(
                    []
                );

                setDisplayResults(
                    "none"
                );

            }

        },
        [likeString]
    );


    //========================================================
    // Events
    //========================================================

    const goBuilding =
        function(id)
        {

            history.push(
                "/facility/" + id
            );

        };


    //--------------------------------------------------------
    // Search change
    //--------------------------------------------------------

    const handleChange =
        function(e)
        {

            setLikeString(
                e.target.value
            );

        };


    //--------------------------------------------------------
    // User
    //--------------------------------------------------------

    const handleUser =
        function(user)
        {

            if(
                user
            )
            {

                if(
                    user.roles.includes(
                        SYSTEM_ROLE_SUPERADMIN
                    )
                    ||
                    user.roles.includes(
                        SYSTEM_ROLE_ADMIN
                    )
                    ||
                    user.roles.includes(
                        SYSTEM_ROLE_CONTENT_CREATOR
                    )
                )
                {

                    setDisplayBlur(
                        false
                    );

                }
                else
                {

                    setDisplayBlur(
                        true
                    );

                }

            }

        };


    //========================================================
    // Styles
    //========================================================

    const pageContainer =
    {
        position: "relative",

        minHeight:
            "100vh",

        overflowX:
            "hidden",

        overflowY:
            isTablet
                ?
                "auto"
                :
                "hidden",

        WebkitOverflowScrolling:
            "touch"
    };


    //--------------------------------------------------------
    // Background
    //--------------------------------------------------------

    const pageBackground =
    {
        position:
            "fixed",

        top:
            0,

        left:
            0,

        width:
            "100vw",

        height:
            "100vh",

        background:
            "radial-gradient(ellipse at center, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0.50) 35%, rgba(255,255,255,0.45) 65%, rgba(255,255,255,0.40) 100%)",

        zIndex:
            0,

        pointerEvents:
            "none"
    };


    //--------------------------------------------------------
    // Main container
    //--------------------------------------------------------

    const thisContainer =
    {
        display:
            "flex",

        flexDirection:
            "column",

        width:
            "100%",

        marginTop:
            "50px",

        minHeight:
            "100vh",

        position:
            "relative",

        zIndex:
            1
    };


    //--------------------------------------------------------
    // Search header row
    //--------------------------------------------------------

    const headerRow =
    {
        position:
            "fixed",

        left:
            "50%",

        top:
            "0px",

        transform:
            "translateX(-50%)",

        display:
            "flex",

        alignItems:
            "center",

        zIndex:
            "300000"
    };


    //--------------------------------------------------------
    // Search
    //--------------------------------------------------------

    const searchPanel =
    {
        display:
            "flex",

        width:
            isTablet
                ?
                "430px"
                :
                "560px",

        height:
            "54px",

        alignItems:
            "center",

        paddingLeft:
            "18px",

        paddingRight:
            "18px",

        marginTop:
            "8px",

        background:
            "rgba(255,255,255,0.72)",

        backdropFilter:
            "blur(20px)",

        WebkitBackdropFilter:
            "blur(20px)",

        borderRadius:
            "28px",

        border:
            "1px solid rgba(255,255,255,0.45)",

        boxShadow:
            "0 8px 25px rgba(0,0,0,0.12)",

        transition:
            "all 0.25s ease"
    };


    const searchInput =
    {
        flexGrow:
            "1",

        height:
            "42px",

        border:
            "0px",

        fontSize:
            "15px",

        background:
            "transparent",

        color:
            "#333",

        outline:
            "none",

        fontWeight:
            "500"
    };


    const searchIcon =
    {
        marginRight:
            "12px",

        color:
            "#5a9bd6",

        fontSize:
            "18px",

        opacity:
            "0.85"
    };


    //--------------------------------------------------------
    // Help
    //--------------------------------------------------------

    const helpIconContainer =
    {
        display:
            "flex",

        width:
            "42px",

        height:
            "42px",

        borderRadius:
            "50%",

        background:
            "linear-gradient(180deg, #45afe0 0%, #2695cc 100%)",

        marginLeft:
            "12px",

        marginTop:
            "8px",

        cursor:
            "pointer",

        alignItems:
            "center",

        justifyContent:
            "center",

        boxShadow:
            "0 6px 16px rgba(0,0,0,0.25)",

        transition:
            "all 0.25s ease"
    };

    const helpIcon =
    {
        color:
            "#ffffff",

        fontSize:
            "18px"
    };


    const topRight =
    {
        display:
            "flex",

        alignItems:
            "center"
    };


    //========================================================
    // Main Content
    //========================================================

    const mainContent =
    {
        display:
            "flex",

        width:
            "calc(100% - 90px)",

        marginLeft:
            "70px",

        marginTop:
            "30px",

        marginBottom:
            "30px",

        justifyContent:
            "space-between",

        alignItems:
            "flex-start",

        gap:
            isTablet
                ?
                "14px"
                :
                "0px"
    };


    //--------------------------------------------------------
    // Desktop column
    //--------------------------------------------------------

    const contentColumn =
    {
        display:
            "flex",

        width:
            isTablet
                ?
                "100%"
                :
                "33%",

        flexDirection:
            "column"
    };


    //--------------------------------------------------------
    // Tablet columns
    //--------------------------------------------------------

    const tabletLeftColumn =
    {
        display:
            "flex",

        flexDirection:
            "column",

        width:
            "52%",

        minWidth:
            0
    };


    const tabletRightColumn =
    {
        display:
            "flex",

        flexDirection:
            "column",

        width:
            "48%",

        minWidth:
            0
    };


    //--------------------------------------------------------
    // Search results
    //--------------------------------------------------------

    const resultsContainer =
    {
        display:
            displayResults,

        position:
            "fixed",

        left:
            posLeft,

        top:
            posTop,

        width:
            isTablet
                ?
                "500px"
                :
                "640px",

        zIndex:
            99999,

        background:
            "rgba(255,255,255,0.88)",

        backdropFilter:
            "blur(20px)",

        WebkitBackdropFilter:
            "blur(20px)",

        borderRadius:
            "18px",

        border:
            "1px solid rgba(255,255,255,0.45)",

        boxShadow:
            "0 10px 30px rgba(0,0,0,0.15)",

        flexDirection:
            "column",

        overflow:
            "hidden",

        marginTop:
            "8px"
    };


    const resultRow =
    {
        display:
            "flex",

        alignItems:
            "center",

        padding:
            "12px 16px",

        cursor:
            "pointer",

        borderBottom:
            "1px solid rgba(0,0,0,0.05)",

        transition:
            "all 0.2s ease"
    };


    //========================================================
    // Mobile
    //========================================================

	if(isMobile)
	{
	    return (
	        <>
	            <MobileHome
	                onAbout={() =>
	                    setShowOmniScanInfo(true)
	                }
	            />

	            {showOmniScanInfo && (
	                <OmniScanEntry
	                    onEnter={() =>
	                        setShowOmniScanInfo(false)
	                    }
	                />
	            )}
	        </>
	    );
	}


    //========================================================
    // Render
    //========================================================

    return (

        <div style={pageContainer}>


            {/* ==============================================
                BACKGROUND
            ============================================== */}

            <div style={pageBackground}/>
			
		


            {/* ==============================================
                FOREGROUND
            ============================================== */}

            <div style={thisContainer}>


                <Header
                    showSurveySelector={true}
                />
				
				
				{/* ==============================================
				              AI INSIGHTS
		          ============================================== */}

		          {
		              isLocalHost
		              &&
		              <AiInsightsPanel
		                  critical={2}
		                  medium={7}
		                  low={15}

		                  onOpen={
		                      function()
		                      {

		                          history.push(
		                              "/insightdashboard"
		                          );

		                      }
		                  }
		              />
		          }


                {/* ==========================================
                    SEARCH
                ========================================== */}

                <div style={headerRow}>

                    <div style={topRight}>

                        <div
                            style={searchPanel}
                            ref={searchId}

                            onMouseEnter={
                                function(e)
                                {

                                    e.currentTarget.style.boxShadow =
                                        "0 0 18px rgba(90,155,214,0.25), 0 8px 25px rgba(0,0,0,0.12)";

                                }
                            }

                            onMouseLeave={
                                function(e)
                                {

                                    e.currentTarget.style.boxShadow =
                                        "0 3px 6px rgba(0,0,0,0.15)";

                                }
                            }
                        >

                            <FontAwesomeIcon
                                icon="search"
                                style={searchIcon}
                            />

                            <input
                                type="text"
                                onChange={handleChange}
                                style={searchInput}
                            />

                        </div>


                        <div
                            style={helpIconContainer}

                            onMouseEnter={
                                function(e)
                                {

                                    e.currentTarget.style.boxShadow =
                                        "0 0 8px #5f8ce9";

                                }
                            }

                            onMouseLeave={
                                function(e)
                                {

                                    e.currentTarget.style.boxShadow =
                                        "0 2px 4px rgba(0,0,0,0.2)";

                                }
                            }

                           onClick={() => setShowOmniScanInfo(true)}
                        >

                            <FontAwesomeIcon
                                icon="question"
                                style={helpIcon}
                            />

                        </div>

                    </div>

                </div>


                {/* ==========================================
                    MAIN CONTENT
                ========================================== */}

                <div style={mainContent}>


                    {
                        isTablet
                        ?
                        <>

                            {/* ==================================
                                TABLET LEFT
                            ================================== */}

                            <div style={tabletLeftColumn}>


                                {/* DATA */}

                                <div style={contentColumn}>

                                    <HeaderCard
                                        id="1"
                                        title="Data"
                                        color={OMNISCAN_BLUE}
                                        icon="chart-bar"
                                        externalLinks={externalLinks}
                                    />


                                    <HomeBoxProperties
                                        homeConfig={homeConfig}
                                    />


                                    <HomeBoxSpace
                                        homeConfig={homeConfig}
                                    />


                                    <HomeDataScroller
                                        homeConfig={homeConfig}
                                        isDemo={isLocalHost}
                                    />

                                </div>


                                {/* DELIVERY */}

                                <div
                                    style={{
                                        ...contentColumn,
                                        marginTop: "18px"
                                    }}
                                >

                                    <HeaderCard
                                        id="3"
                                        title="Delivery"
                                        color={OMNISCAN_BLUE}
                                        icon="traffic-light"
                                        externalLinks={externalLinks}
                                    />


                                    <HomeBoxMyTasks />


                                    <HomeBoxTasks
                                        homeConfig={homeConfig}
                                    />


                                    <HomeBoxProjects
                                        homeConfig={homeConfig}
                                    />


                                    <HomeBoxHelpDesk />

                                </div>

                            </div>


                            {/* ==================================
                                TABLET RIGHT
                            ================================== */}

                            <div style={tabletRightColumn}>

                                <HeaderCard
                                    id="2"
                                    title="Documents"
                                    color={OMNISCAN_BLUE}
                                    icon="file"
                                    externalLinks={externalLinks}
                                />


                                {
                                    !isLocalHost
                                    &&
                                    <>

                                        <HomeBoxDocuments />


                                        <HomeBoxLeases
                                            homeConfig={homeConfig}
                                        />

                                    </>
                                }


                                {
                                    isLocalHost
                                    &&
                                    <HomeDocumentsPanel
                                        directories={directories}
                                    />
                                }

                            </div>

                        </>
                        :
                        <>

                            {/* ==================================
                                DESKTOP DATA
                            ================================== */}

                            <div style={contentColumn}>

                                <HeaderCard
                                    id="1"
                                    title="Data"
                                    color={OMNISCAN_BLUE}
                                    icon="chart-bar"
                                    externalLinks={externalLinks}
                                />


                                <HomeBoxProperties
                                    homeConfig={homeConfig}
                                />


                                <HomeBoxSpace
                                    homeConfig={homeConfig}
                                />


                                <HomeDataScroller
                                    homeConfig={homeConfig}
                                    isDemo={isLocalHost}
                                />

                            </div>


                            {/* ==================================
                                DESKTOP DOCUMENTS
                            ================================== */}

                            <div style={contentColumn}>

                                <HeaderCard
                                    id="2"
                                    title="Documents"
                                    color={OMNISCAN_BLUE}
                                    icon="file"
                                    externalLinks={externalLinks}
                                />


                                {
                                    !isLocalHost
                                    &&
                                    <>

                                        <HomeBoxDocuments />


                                        <HomeBoxLeases
                                            homeConfig={homeConfig}
                                        />

                                    </>
                                }


                                {
                                    isLocalHost
                                    &&
                                    <HomeDocumentsPanel
                                        directories={directories}
                                    />
                                }

                            </div>


                            {/* ==================================
                                DESKTOP DELIVERY
                            ================================== */}

                            <div style={contentColumn}>

                                <HeaderCard
                                    id="3"
                                    title="Delivery"
                                    color={OMNISCAN_BLUE}
                                    icon="traffic-light"
                                    externalLinks={externalLinks}
                                />


                                <HomeBoxMyTasks />


                                <HomeBoxTasks
                                    homeConfig={homeConfig}
                                />


                                <HomeBoxProjects
                                    homeConfig={homeConfig}
                                />


                                <HomeBoxHelpDesk />

                            </div>

                        </>
                    }

                </div>


                {/* ==========================================
                    SEARCH RESULTS
                ========================================== */}

                <div style={resultsContainer}>

                    {
                        locations.length > 0
                        &&
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",

                                minHeight: "36px",

                                padding: "0 16px",

                                background:
                                    "linear-gradient(100deg, #0c3558 0%, #10456f 100%)",

                                borderBottom:
                                    "2px solid rgba(141,200,240,0.55)",

                                color: "#ffffff"
                            }}
                        >

                            <div
                                style={{
                                    fontSize: "11px",
                                    fontWeight: "600",
                                    letterSpacing: "1px",
                                    textTransform: "uppercase"
                                }}
                            >
                                Matching Buildings
                            </div>

                            <div
                                style={{
                                    fontSize: "10px",
                                    fontWeight: "600",
                                    color: "#8dc8f0",
                                    letterSpacing: "0.6px"
                                }}
                            >
                                {
                                    locations.length === 1
                                        ? "1 RESULT"
                                        : locations.length + " RESULTS"
                                }
                            </div>

                        </div>
                    }


                    {
                        locations.map(
                            function(item)
                            {
                                return (

                                    <div
                                        key={item.id}

                                        onClick={
                                            function()
                                            {
                                                goBuilding(
                                                    item.id
                                                );
                                            }
                                        }

                                        style={{
                                            ...resultRow,

                                            display: "flex",
                                            alignItems: "center",

                                            minHeight: "52px",

                                            padding: "0 14px",

                                            background:
                                                "rgba(255,255,255,0.96)",

                                            borderBottom:
                                                "1px solid rgba(12,53,88,0.08)",

                                            transition:
                                                "all 0.16s ease"
                                        }}

                                        onMouseEnter={
                                            function(e)
                                            {
                                                e.currentTarget.style.background =
                                                    "linear-gradient(90deg, rgba(141,200,240,0.18) 0%, rgba(141,200,240,0.05) 100%)";

                                                e.currentTarget.style.boxShadow =
                                                    "inset 3px 0 0 #8dc8f0";
                                            }
                                        }

                                        onMouseLeave={
                                            function(e)
                                            {
                                                e.currentTarget.style.background =
                                                    "rgba(255,255,255,0.96)";

                                                e.currentTarget.style.boxShadow =
                                                    "none";
                                            }
                                        }
                                    >

                                        {/* Building icon */}

                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",

                                                width: "34px",
                                                height: "34px",

                                                flexShrink: 0,

                                                marginRight: "12px",

                                                background: "#0c3558",

                                                borderBottom:
                                                    "2px solid #8dc8f0"
                                            }}
                                        >

                                            <FontAwesomeIcon
                                                icon="building"
                                                style={{
                                                    color: "#8dc8f0",
                                                    fontSize: "14px"
                                                }}
                                            />

                                        </div>


                                        {/* Building details */}

                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                flexGrow: 1
                                            }}
                                        >

                                            <div
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: "600",
                                                    color: "#243746"
                                                }}
                                            >
                                                {item.name}
                                            </div>

                                            <div
                                                style={{
                                                    marginTop: "2px",
                                                    fontSize: "10px",
                                                    fontWeight: "500",
                                                    color: "#81909c",
                                                    letterSpacing: "0.5px",
                                                    textTransform: "uppercase"
                                                }}
                                            >
                                                Building
                                            </div>

                                        </div>


                                        {/* Chevron */}

                                        <FontAwesomeIcon
                                            icon="chevron-right"
                                            style={{
                                                color: "#0c3558",
                                                fontSize: "12px",
                                                marginLeft: "12px"
                                            }}
                                        />

                                    </div>

                                );
                            }
                        )
                    }

                </div>

            </div>

			{showOmniScanInfo && (

			    <OmniScanEntry
			        onEnter={() => setShowOmniScanInfo(false)}
			    />

			)}
          

            <LeftMenu />

        </div>

    );

}
